/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChefEntrepriseGridDto } from './ChefEntrepriseGridDto';
import {
    ChefEntrepriseGridDtoFromJSON,
    ChefEntrepriseGridDtoFromJSONTyped,
    ChefEntrepriseGridDtoToJSON,
} from './ChefEntrepriseGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ChefEntrepriseGridDtoPaginatedResults
 */
export interface ChefEntrepriseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ChefEntrepriseGridDto>}
     * @memberof ChefEntrepriseGridDtoPaginatedResults
     */
    results?: Array<ChefEntrepriseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ChefEntrepriseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ChefEntrepriseGridDtoPaginatedResults interface.
 */
export function instanceOfChefEntrepriseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefEntrepriseGridDtoPaginatedResultsFromJSON(json: any): ChefEntrepriseGridDtoPaginatedResults {
    return ChefEntrepriseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ChefEntrepriseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefEntrepriseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ChefEntrepriseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ChefEntrepriseGridDtoPaginatedResultsToJSON(value?: ChefEntrepriseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ChefEntrepriseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

